import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Navbar from "../Navbar";
import Footer from "../Footer";
import SupplierSidebar from "./supplierSidebar";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { handleAPIRequest } from "../../../api/api";
const Portfolio = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Separate states for each document
  const [NTN, setNTN] = useState({ file: null, tag: "" });
  const [BankStatement, setBankStatement] = useState({ file: null, tag: "" });
  const [PastOrders, setPastOrders] = useState({ file: null, tag: "" });

  const token = useSelector((state) => state.auth.token);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Fetch documents from the database
  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await handleAPIRequest(
          "get",
          "get-portfolio-documents",
          null,
          null,
          token
        );
        if (response) {
          if (response.ntn && response.ntn.length > 0) {
            setNTN({
              file: response.ntn[0].document_url,
              tag: response.ntn[0].document_tag,
            });
          }
          if (response.bank_statement && response.bank_statement.length > 0) {
          setBankStatement({
            file: response.bank_statement[0].document_url,
            tag: response.bank_statement[0].document_tag,
          });
        }
        if (response.past_orders && response.past_orders.length > 0) {
          setPastOrders({
            file: response.past_orders[0].document_url,
            tag: response.past_orders[0].document_tag,
          });
        }
        } else {
          toast.error("Failed to fetch documents.");
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
        toast.error("Error fetching documents.");
      }
    };

    fetchDocuments();
  }, [token]);

  const handleFileChange = (e, type) => {
    const { files } = e.target;
    if (files[0]) {
      if (type === "NTN") setNTN((prev) => ({ ...prev, file: files[0] }));
      if (type === "BankStatement")
        setBankStatement((prev) => ({ ...prev, file: files[0] }));
      if (type === "PastOrders")
        setPastOrders((prev) => ({ ...prev, file: files[0] }));
    }
  };

  const handleTagChange = (e, type) => {
    const { value } = e.target;
    if (type === "NTN") setNTN((prev) => ({ ...prev, tag: value }));
    if (type === "BankStatement")
      setBankStatement((prev) => ({ ...prev, tag: value }));
    if (type === "PastOrders")
      setPastOrders((prev) => ({ ...prev, tag: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    if (NTN.file && NTN.file instanceof File) {
        formData.append("ntn_doc", NTN.file);
        formData.append("ntn_tag", NTN.tag);
      }
    
      // Add Bank Statement document if it's a File
      if (BankStatement.file && BankStatement.file instanceof File) {
        formData.append("bank_statement_doc", BankStatement.file);
        formData.append("bank_statement_tag", BankStatement.tag);
      }
    
      // Add Past Orders document if it's a File
      if (PastOrders.file && PastOrders.file instanceof File) {
        formData.append("past_orders_doc", PastOrders.file);
        formData.append("past_orders_tag", PastOrders.tag);
      }
    try {
      const response = await handleAPIRequest(
        "post",
        "add-portfolio-documents",
        formData,
        null,
        token
      );
      if (response) {
        toast.success("Profile edited successfully!");
      }
    } catch (error) {
      console.error("Error uploading documents:", error);
      toast.error("Error uploading documents. Please try again.");
    }
  };

  return (
    <div className="flex flex-col md:flex-row">
      <SupplierSidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className="flex-1 flex flex-col">
        <Navbar toggleSidebar={toggleSidebar} />
        <main className="p-4 md:p-6">
          <ToastContainer />
          <h1 className="text-2xl md:text-3xl font-bold mb-4 text-center md:text-left">
            Supplier Portfolio
          </h1>

          {/* Upload Documents Section */}
          <div className="bg-gray-100 rounded-lg shadow-md p-4 md:p-6 mb-6">
            <h2 className="text-xl md:text-2xl font-semibold mb-4">
              Upload Documents
            </h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              {[
                { doc: "NTN", state: NTN, setState: setNTN },
                {
                  doc: "BankStatement",
                  state: BankStatement,
                  setState: setBankStatement,
                },
                {
                  doc: "PastOrders",
                  state: PastOrders,
                  setState: setPastOrders,
                },
              ].map(({ doc, state }, index) => (
                <div key={index} className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    {doc.replace(/([A-Z])/g, " $1")}
                  </label>
                  <div className="flex items-center space-x-4 mt-2">
                    <input
                      type="file"
                      onChange={(e) => handleFileChange(e, doc)}
                      className="text-sm"
                    />
                    <input
                      type="text"
                      placeholder="Add Tag"
                      value={state.tag}
                      onChange={(e) => handleTagChange(e, doc)}
                      className="h-10 border-gray-300 rounded-md p-2 text-sm w-60"
                    />
                  </div>
                </div>
              ))}
              <div className="text-center">
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition text-sm md:text-base"
                >
                  Save Documents
                </button>
              </div>
            </form>
          </div>

          {/* Download Documents Section */}
          <div className="bg-gray-100 rounded-lg shadow-md p-4 md:p-6">
            <h2 className="text-xl md:text-2xl font-semibold mb-4">
              Download Documents
            </h2>
            <div className="space-y-4">
              {[
                { doc: "NTN", state: NTN },
                { doc: "BankStatement", state: BankStatement },
                { doc: "PastOrders", state: PastOrders },
              ].map(({ doc, state }, index) => (
                <div key={index} className="flex justify-between items-center">
                  <span className="text-sm font-medium text-gray-700">
                    {doc.replace(/([A-Z])/g, " $1")}
                  </span>
                  {state.file ? (
                    typeof state.file === "string" ? (
                      <a
                        href={state.file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline text-sm"
                      >
                        Download {doc}
                      </a>
                    ) : (
                      <a
                        href={URL.createObjectURL(state.file)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline text-sm"
                      >
                        Download {doc}
                      </a>
                    )
                  ) : (
                    <span className="text-gray-500 text-sm">
                      No file uploaded
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Portfolio;
